import { defineMessages } from 'react-intl';

const messages = defineMessages({
  appHeader: {
    id: 'ApplicationHeader.AppHeader',
    defaultMessage: 'UNFI Product Information',
  },
  searchPlaceholder: {
    id: 'ApplicationHeader.SearchPlaceholder',
    defaultMessage: 'Search…',
  },
});

export default messages;
